import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useAuthStore } from "../../../store/AuthStore";
import utils from "../../../utils";
import constants from "../../../constants";
import DepartmentAddEdit from "../DepartmentAddEdit/Index";
import { deleteDepartment, deleteDepartments, getDepartments } from "../../../apis/Department";

const DepartmentList = ({ toast, facultyId }) => {

  const [state] = useAuthStore();

  let emptySession = {
    id: null,
    facultyId: facultyId,
    name: "",
    description: "",
    createdBy: state.email,
    modifiedBy: state.email,
  };

  const [departments, setDepartments] = useState(null);
  const [departmentDialog, setDepartmentDialog] = useState(false);
  const [deleteDepartmentDialog, setDeleteDepartmentDialog] = useState(false);
  const [deleteDepartmentsDialog, setDeleteDepartmentsDialog] = useState(false);
  const [department, setDepartment] = useState(emptySession);
  const [selectedDepartments, setSelectedDepartments] = useState(null);
  const [, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toastDL = useRef(toast);
  const dt = useRef(null);

  async function fetchDepartmentsData() {
    var res = await getDepartments(facultyId);
    setDepartments(res.data);
  }

  useEffect(() => {
    fetchDepartmentsData();
  }, [departmentDialog, deleteDepartmentDialog, deleteDepartmentsDialog, globalFilter]);

  const openNew = () => {
    setDepartment(emptySession);
    setSubmitted(false);
    setDepartmentDialog(true);
  };

  const confirmDeleteSelected = () => {
    setDeleteDepartmentsDialog(true);
  };

  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap">
        <Button
          icon="pi pi-plus"
          severity="success"
          rounded
          outlined
          className="mr-2"
          onClick={openNew}
        />
      </div>
    );
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const rightToolbarTemplate = () => {
    return (
      <Button
        label="Export"
        icon="pi pi-upload"
        className="p-button-help"
        onClick={exportCSV}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          className="mr-2"
          onClick={() => editDepartment(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteDepartment(rowData)}
        />
      </React.Fragment>
    );
  };

  const editDepartment = (departmentData) => {
    setDepartment({ ...departmentData });
    setDepartmentDialog(true);
  };

  const confirmDeleteDepartment = (departmentData) => {
    setDepartment(departmentData);
    setDeleteDepartmentDialog(true);
  };

  const hideDeleteDepartmentDialog = () => {
    setDeleteDepartmentDialog(false);
  };

  const hideDeleteDepartmentsDialog = () => {
    setDeleteDepartmentsDialog(false);
  };

  const deleteDepartmentFunc = async () => {
    let resp = {
      data: null,
      responseCode: "",
      responseCodeDescription: "",
    };

    try {
      if (department && department.id) {
        resp = await deleteDepartment(department.id);
        setDeleteDepartmentDialog(false);
        setDepartment(emptySession);
        toastDL.current.show(
          utils.toastCallback({
            severity: "success",
            summary: "Successful",
            detail: resp.responseCodeDescription,
          })
        );
      }
    } catch (error) {
      if (error.response) {
        resp = error.response;

        toast.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Submit Error",
            detail: resp.responseCodeDescription,
          })
        );
      } else {
        toast.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Network Error",
            detail: constants.networkErrorMessage,
          })
        );
      }
    }
  };

  const deleteSelectedDepartments = async () => {
    let resp = {
      data: null,
      responseCode: "",
      responseCodeDescription: "",
    };

    try {
      let _departments = departments.filter((val) => !selectedDepartments.includes(val));
      resp = await deleteDepartments(_departments);
      setDeleteDepartmentsDialog(false);
      setSelectedDepartments(null);
      toastDL.current.show(
        utils.toastCallback({
          severity: "success",
          summary: "Successful",
          detail: resp.responseCodeDescription,
        })
      );
    } catch (error) {
      if (error.response) {
        resp = error.response;

        toast.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Submit Error",
            detail: resp.responseCodeDescription,
          })
        );
      } else {
        toast.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Network Error",
            detail: constants.networkErrorMessage,
          })
        );
      }
    }
  };

  const deleteDepartmentDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteDepartmentDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={async () => await deleteDepartmentFunc()}
      />
    </React.Fragment>
  );

  const deleteDepartmentsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteDepartmentsDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedDepartments}
      />
    </React.Fragment>
  );



  return (
    <div>

      <Toast ref={toastDL} />

        <DataTable
          value={departments}
          header={leftToolbarTemplate}
        >
          <Column
            field="name"
            header="Name"
            sortable
          ></Column>
          <Column
            field="description"
            header="Description"
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
          ></Column>
        </DataTable>

      <Dialog
        visible={deleteDepartmentDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteDepartmentDialogFooter}
        onHide={hideDeleteDepartmentDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {department && (
            <span>
              Are you sure you want to delete <b>{department.name}</b>?
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deleteDepartmentsDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteDepartmentsDialogFooter}
        onHide={hideDeleteDepartmentsDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {department && (
            <span>Are you sure you want to delete the selected departments?</span>
          )}
        </div>
      </Dialog>

      <DepartmentAddEdit
        toast = {toastDL}
        departmentAE = {department}
        facultyId = {facultyId}
        departmentDialog = {departmentDialog}
        setDepartmentDialog = {setDepartmentDialog}
      />
    </div>
  );
};

export default DepartmentList;
